// Maison Virtus — scroll-reveal layer.
// Hidden states only exist under `html.mv-motion`, so no-JS, reduced-motion,
// save-data and theme-editor sessions always see a fully visible page.
import { prefersReducedMotion } from '@theme/utilities';

const SECTION_SELECTOR = '#MainContent > .shopify-section';
const STAGGER_SELECTORS = ['.resource-list__item', '.editorial-product__grid > *', '.product-grid__item'];

function init() {
  if (prefersReducedMotion()) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (navigator.connection?.saveData) return;
  if (document.documentElement.classList.contains('mv-motion')) return;

  document.documentElement.classList.add('mv-motion');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mv-in');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  // The module loads after first paint — anything already on screen must not
  // flash from visible to hidden, so only elements below the fold participate.
  const belowFold = (element) => element.getBoundingClientRect().top > window.innerHeight;

  // The first section holds the LCP media — never hide it.
  const sections = [...document.querySelectorAll(SECTION_SELECTOR)].slice(1);
  for (const section of sections) {
    if (!belowFold(section)) continue;
    section.classList.add('mv-reveal');
    observer.observe(section);
  }

  for (const selector of STAGGER_SELECTORS) {
    document.querySelectorAll(selector).forEach((element, index) => {
      if (!belowFold(element)) return;
      element.classList.add('mv-stagger');
      element.style.setProperty('--mv-i', String(index % 8));
      observer.observe(element);
    });
  }
}

init();

window.addEventListener('pageshow', (event) => {
  if (event.persisted) init();
});
